import { registerLocaleData } from "@angular/common";
import localeNl from "@angular/common/locales/nl";
import { ChangeDetectionStrategy, Component, inject } from "@angular/core";
import { NavigationStart, RouteConfigLoadEnd, RouteConfigLoadStart, Router } from "@angular/router";

import { LgLoaderService } from "@logex/framework/lg-layout";

@Component({
    selector: "app-root",
    template: "<router-outlet></router-outlet>",
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class AppComponent {
    private _loaderService = inject(LgLoaderService);
    private _router = inject(Router);

    constructor() {
        // translateInitialize( translateService );
        registerLocaleData(localeNl);
        this._router.events.subscribe(ev => {
            if (ev instanceof RouteConfigLoadStart) {
                this._loaderService.show();
            } else if (ev instanceof RouteConfigLoadEnd) {
                this._loaderService.hide();
            } else if (ev instanceof NavigationStart) {
                if (ev.url && ev.url.match(/^\/#!/)) {
                    this._router.navigate([ev.url.replace("/#!", "")]);
                }
            }
        });
    }
}
